import { render, staticRenderFns } from "./DpaFileViewLogs.vue?vue&type=template&id=8fed3242&"
import script from "./DpaFileViewLogs.vue?vue&type=script&lang=js&"
export * from "./DpaFileViewLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports